import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiTextareaComponent } from "../../shared/form/textarea/new-ui-textarea.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-textarea",
  templateUrl: "./new-ui-formly-textarea.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
    NewUiTextareaComponent,
  ],
})
export class NewUiFormlyTextareaComponent extends FieldType {}
